export function parseDate(dateUnparse: string | undefined) {
  if (!dateUnparse) return null;
  const date = new Date(dateUnparse);
  const formattedDate = `${date.getDate()}/${
    date.getMonth() + 1
  }/${date.getFullYear()}`;
  const formattedTime = `${date.getHours()}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}h`;
  return `${formattedDate} às ${formattedTime}`;
}
